import * as React from "react";
import { siteColors } from "../variables/colors";
import { Copy } from "./Copy";
import { Logo } from "./Logo";
import { Spacer } from "./Spacer";

const Footer = class extends React.Component {
  render() {
    return (
      <footer>
        <div
          className="content has-text-centered"
          style={{
            backgroundColor: `${siteColors.cyan}`,
          }}
        >
          <div
            style={{
              padding: "30px 0",
            }}
          >
            <Copy fontSize={24} color="white">
              If you are a school, business or individual please contact us on
              the details below and we will be in touch.
            </Copy>
            <Spacer height={12} />
            <div className="nav-contact footer-nav-contact">
              <a className="navlink">Jane@elsa.education | </a>
              <a className="navlink">07745 585702</a>
            </div>
            <Spacer height={16} />
            <Copy fontSize={18} color="white">
              ELSA Next Generation is a Registered Community Interest Company
              No.12844533
            </Copy>
          </div>
        </div>
      </footer>
    );
  }
};

export default Footer;
